var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgChatMessageDark = function SvgChatMessageDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Chat/ Message",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4300"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4181",
    transform: "translate(-290 -734)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 983",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(290 734)",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon / Comment"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-comment-alt",
    d: "M312.6 741.5h-13.8a2.3 2.3 0 00-2.3 2.3v10.35a2.3 2.3 0 002.3 2.3h3.45v3.019a.432.432 0 00.686.349l4.489-3.367h5.175a2.3 2.3 0 002.3-2.3V743.8a2.3 2.3 0 00-2.3-2.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }))))));
};
export default SvgChatMessageDark;